/** Components */
import "../components/loader/index";
import CCCEventCarousel from "../components/event-carousel/eventCarousel";
/** Controllers */
import GlobalEventCalendarListController from "../controllers/GlobalEventCalendarListController";
import SearchPanelController from "../controllers/SearchPanelController";
import EventCarouselController from "../controllers/EventCarouselController";
import TwitterPanel from "../controllers/TwitterPanel";
import { getPathPosition } from "../core/utilities";
import EventModel from "../models/EventModel";
import AnnouncementsController from "../controllers/AnnouncementsController";
import { VanillaPagesType } from "../core/types/VanillaPages";
import TestimonialPanelController from "../controllers/TestimonialPanelController";
import ReportSharingCenterController from "../controllers/ReportSharingCenterController";
import UpcomingEventListController from "../controllers/UpcomingEventsListController";
/** Other */

const remove_header = async () => {
  // only when we're in all events category page
  if (await EventModel.isGlobalEventsCategoryPage()) {
    const el = document.querySelector(".ccc_banner");
    if (el) {
      el.remove();
    }
  }
};

const remove_empty_message = async () => {
  // only when we're in all events category page
  if (await EventModel.isGlobalEventsCategoryPage()) {
    const el = document.querySelector("section.pageBox div.Empty");
    if (el) {
      el.remove();
    }
  }
};

const events_load = async () => {
  const events = new GlobalEventCalendarListController(
    "#GlobalEventCalendar",
    "#GlobalEventList",
    "#GlobalEventsPanel"
  );
  events.init();
};

/**
 * Initializes search panel component.
 */
const search_load = async (): Promise<void> => {
  const searchPanel: SearchPanelController = new SearchPanelController(
    "#SearchPanel"
  );
  searchPanel.init();
};

const event_carousel_load = async () => {
  const eventCarouselController: EventCarouselController =
    new EventCarouselController("#CCCEventsCarousel");

  const $cccEventCarousel: CCCEventCarousel =
    await eventCarouselController.init();
  if ($cccEventCarousel) $cccEventCarousel.style.marginBottom = "3em";
};

const announcements_load = (categoriesName: string) => {
  const announcementPanels = new AnnouncementsController();
  announcementPanels.init(VanillaPagesType.discussions, {
    anchor: "#CCCAnnouncements",
    catName: categoriesName,
  });
};

const twitter_panel_load = async (categoriesName: string) => {
  const tpanels = new TwitterPanel();
  tpanels.init(
    "#TwitterPanels",
    process.env.DATA_URL + `twitter-accounts/${categoriesName}.txt`
  );
};

const testimonial_panel_load = (categoryName: string) => {
  const tp = new TestimonialPanelController();
  tp.init(VanillaPagesType.categories, "#CCCTestimonialQuote", categoryName);
};

const report_sharing_center_load = (categoriesName: string) => {
  if (categoriesName.includes("report-sharing-center")) {
    const rsc = new ReportSharingCenterController();

    rsc.init(categoriesName, "#CCCReportSharingCenter", 30);
  }
};

const upcoming_events_load = (categoriesName: string) => {
  const upcomingEventsPanel = new UpcomingEventListController();
  upcomingEventsPanel.init(VanillaPagesType.discussions, categoriesName);
};

// seq code
const categories_recipe = () => {
  console.info("Categories recipe");
  const categoriesName = getPathPosition(3);
  remove_header();
  remove_empty_message();
  events_load();
  search_load();
  event_carousel_load();
  announcements_load(categoriesName);
  twitter_panel_load(categoriesName);
  testimonial_panel_load(categoriesName);
  report_sharing_center_load(categoriesName);
  upcoming_events_load(categoriesName);
};

categories_recipe();
